import React, { useState } from 'react';
import { Play, Clock, Users, Award } from 'lucide-react';
import VideoModal from './VideoModal';
import { scrollToSection } from '../utils/navigation';

const HeroSection = () => {
  const [showDemo, setShowDemo] = useState(false);
  
  return (
    <section id="accueil" className="relative min-h-screen bg-gradient-to-br from-red-900 via-red-800 to-orange-800">
      {/* Background Image Overlay */}
      <div className="absolute inset-0 bg-black/40"></div>
      
      {/* Hero Content */}
      <div className="relative z-10 container mx-auto px-4 pt-20 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          {/* Left Content */}
          <div className="text-white space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
                Maîtrisez l'Art de la
                <span className="block text-yellow-400">Pizza Napolitaine</span>
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                Formation d'excellence avec Joseph Cardone, maître pizzaïolo avec plus de 30 ans d'expérience. 
                Apprenez les techniques authentiques de la pizza napolitaine traditionnelle.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-yellow-400 rounded-full mx-auto mb-2">
                  <Users className="h-6 w-6 text-red-900" />
                </div>
                <div className="text-2xl font-bold">500+</div>
                <div className="text-sm text-gray-300">Élèves formés</div>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-yellow-400 rounded-full mx-auto mb-2">
                  <Clock className="h-6 w-6 text-red-900" />
                </div>
                <div className="text-2xl font-bold">40h</div>
                <div className="text-sm text-gray-300">Formation complète</div>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center w-12 h-12 bg-yellow-400 rounded-full mx-auto mb-2">
                  <Award className="h-6 w-6 text-red-900" />
                </div>
                <div className="text-2xl font-bold">99%</div>
                <div className="text-sm text-gray-300">Taux de réussite</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => scrollToSection('expert-napolitaine')}
                className="bg-yellow-400 text-red-900 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-yellow-300 transition-colors text-center"
              >
                Découvrir la Formation Expert
              </button>
              <button 
                onClick={() => setShowDemo(true)}
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-red-900 transition-colors text-center flex items-center justify-center gap-2"
              >
                <Play className="h-5 w-5" />
                Voir la Démo
              </button>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="./images/pizza_napolitaine_1.jpeg" 
                alt="Pizza napolitaine authentique au four à bois"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Pizza Napolitaine Authentique</h3>
                <p className="text-gray-200">Cuite au four à bois traditionnel</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
      
      {/* Demo Video Modal */}
      <VideoModal 
        isOpen={showDemo}
        onClose={() => setShowDemo(false)}
        title="Démonstration - Art de la Pizza Napolitaine"
        description="Découvrez un aperçu de nos techniques d'enseignement et de l'expertise de Joseph Cardone dans cette vidéo de démonstration. Vous y verrez les gestes authentiques de la pizza napolitaine traditionnelle."
      />
    </section>
  );
};

export default HeroSection;